module.exports = __webpack_public_path__ + "static/media/TW-father-joe-mobile-411x93.7714affc.jpg";